import { moneyFormatter } from "utils/general";
import StatisticsStyles from "./index.module.scss";
import { FC } from "react";


interface IProps {
  main?: boolean
}


const Statistics: FC<IProps> = ({ main }) => {
  return (
    <section
      className={`${StatisticsStyles.statistics} ${
        main ? StatisticsStyles.main_statistics : ""
      }`}
    >
      <div className="container">
        <div className={StatisticsStyles.header__statistics + " align-center"}>
          <span className={StatisticsStyles.icon__header}>
            <svg
              viewBox="0 0 239 33"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M111.141 3.93613V27.1551H150.365V32.2851H108.834C107.457 32.2851 106.484 31.6636 105.912 30.4206C105.642 29.8358 105.491 29.2029 105.468 28.5591V6.41467L111.141 3.93613Z"
                fill="#3D3D3D"
              />
              <path
                d="M193.104 32.2851H185.622L185.782 7.82312L191.427 5.19405V26.6648H196.897L196.723 2.72743L202.577 0L202.498 27.1551H238.226V32.2851H193.104Z"
                fill="#3D3D3D"
              />
              <path
                d="M180.629 13.5865C178.796 11.7533 176.579 10.8367 173.978 10.8367H172.775C170.156 10.8367 167.938 11.7533 166.123 13.5865C164.29 15.4187 163.373 17.6359 163.373 20.2382L163.333 21.7897L168.997 21.6809V20.2382C169.006 19.2382 169.407 18.2819 170.114 17.5748C170.821 16.8677 171.778 16.4663 172.778 16.457H173.98C174.979 16.4679 175.934 16.8701 176.639 17.5771C177.344 18.2841 177.744 19.2395 177.753 20.2382V27.1343H155.784V32.0436H183.373V20.2382C183.376 17.6379 182.461 15.4207 180.629 13.5865Z"
                fill="#3D3D3D"
              />
              <path
                d="M69.9217 6.51289L73.2364 9.82755L76.5496 6.48904L73.2364 3.15054L69.9217 6.46371L66.6339 3.15054L63.2954 6.48904L66.6339 9.82755L69.9217 6.51289Z"
                fill="#3D3D3D"
              />
              <path
                d="M94.0262 6.41488L90.713 3.07787L87.3745 6.41488L90.713 9.75338L94.0262 6.41488Z"
                fill="#3D3D3D"
              />
              <path
                d="M99.4525 14.8893C97.6034 13.0561 95.3862 12.1395 92.8008 12.1395H85.5605L85.5396 17.7613H92.8008C98.7431 18.3157 97.7192 24.8839 97.4896 27.0152H75.2022V12.1395H69.5565V27.2596H64.8975V27.2358H59.845V20.3397C59.845 17.7374 58.9289 15.5202 57.0967 13.688C55.2645 11.8558 53.0458 10.9392 50.4406 10.9382H49.2483C46.6301 10.9382 44.4129 11.8548 42.5966 13.688C40.7634 15.5212 39.8468 17.7384 39.8468 20.3397L39.8066 21.8912L45.4701 21.7824V20.3397C45.4791 19.3403 45.8799 18.3843 46.5865 17.6775C47.2931 16.9706 48.2489 16.5693 49.2483 16.56H50.4406C51.4405 16.5682 52.3971 16.969 53.1042 17.6761C53.8113 18.3832 54.2121 19.3398 54.2203 20.3397V27.2373H35.3652V3.79472L29.7017 6.35673V28.4102C29.7239 29.0559 29.876 29.6905 30.1488 30.2762C30.7211 31.5192 31.6948 32.1412 33.07 32.1422H102.324V22.1416C102.324 19.5572 101.286 16.7389 99.4525 14.8893Z"
                fill="#3D3D3D"
              />
              <path
                d="M20.5819 26.6662H10.1252C9.63261 26.6733 9.14407 26.5764 8.69153 26.3817C8.23899 26.187 7.83266 25.899 7.49911 25.5364C7.14366 25.1934 6.86229 24.7811 6.67234 24.3251C6.4824 23.8691 6.38791 23.379 6.39472 22.885V21.7314C6.42751 20.6688 6.41112 17.1708 6.41112 17.1708C6.41112 17.1708 0.774414 17.1797 0.774414 17.2483V22.885C0.774414 25.4709 1.36163 27.9822 3.17694 29.8318C4.99225 31.6814 7.53935 32.285 10.1252 32.285H26.2022L26.2364 6.35197L20.5819 3.59026V26.6662Z"
                fill="#3D3D3D"
              />
              <path
                d="M18.8377 3.59776L12.9834 6.3252V13.2392L18.8183 10.4253L18.8377 3.59776Z"
                fill="#F67F00"
              />
            </svg>
          </span>
          <span className={StatisticsStyles.title__header}>
            <h4>بزرگترین بازار آنلاین کابینت و دکوراسیون داخلی</h4>
          </span>
        </div>
        <div className={StatisticsStyles.content__statistics}>
          <ul className="flex flex-row jcb align-i-center">
            <li>
              <span className={StatisticsStyles.number__content}>
                <h5>{moneyFormatter(450000)}+</h5>
              </span>
              <span className={StatisticsStyles.caption__content}>
                کاربر ماهانه از سراسر ایران
              </span>
            </li>
            <li className={StatisticsStyles.special__content}>
              <span className={StatisticsStyles.number__content}>
                <h5>{moneyFormatter(250)}+</h5>
              </span>
              <span className={StatisticsStyles.caption__content}>
                کابینت ساز تایید صلاحیت شده
              </span>
            </li>
            <li>
              <span className={StatisticsStyles.number__content}>
                <h5>{moneyFormatter(200000)}+</h5>
              </span>
              <span className={StatisticsStyles.caption__content}>
                ثبت درخواست معرفی کابینت ساز
              </span>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default Statistics